(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-section-type="wp-featured-collection"]').forEach(function(sec){
    var track = sec.querySelector('[data-wp-fc-track]');
    var prev  = sec.querySelector('[data-wp-fc-prev]');
    var next  = sec.querySelector('[data-wp-fc-next]');
    if(!track) return;
    function step(){
      var card = track.querySelector('.wp-fc__card');
      if(!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || 0,10) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ track.scrollBy({left: step(),behavior:'smooth'}); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
